import React from 'react';
import styled from 'styled-components';
import { Tag } from '../tag/_Tag';

const StyledTag = styled(Tag)`
  user-select: none;
  pointer-events: none;
`;

export const Plus = ({ number }) => {
  if (number <= 0) {
    return null;
  }

  return <StyledTag>+{Math.min(number, 99)}</StyledTag>;
};
